/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Suggest_FrequencyInputs */

const en_us2_coach_suggest_frequency = /** @type {(inputs: Coach_Suggest_FrequencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I train 4 times a week?`)
};

const pt_br2_coach_suggest_frequency = /** @type {(inputs: Coach_Suggest_FrequencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso treinar 4x por semana?`)
};

const es_419_coach_suggest_frequency = /** @type {(inputs: Coach_Suggest_FrequencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Puedo entrenar 4 veces por semana?`)
};

const pt_pt2_coach_suggest_frequency = /** @type {(inputs: Coach_Suggest_FrequencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso treinar 4x por semana?`)
};

const fr_fr2_coach_suggest_frequency = /** @type {(inputs: Coach_Suggest_FrequencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je peux m'entraîner 4 fois par semaine ?`)
};

const de_de2_coach_suggest_frequency = /** @type {(inputs: Coach_Suggest_FrequencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kann ich 4-mal pro Woche trainieren?`)
};

const it_it2_coach_suggest_frequency = /** @type {(inputs: Coach_Suggest_FrequencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso allenarmi 4 volte a settimana?`)
};

/**
* | output |
* | --- |
* | "Can I train 4 times a week?" |
*
* @param {Coach_Suggest_FrequencyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_suggest_frequency = /** @type {((inputs?: Coach_Suggest_FrequencyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Suggest_FrequencyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_suggest_frequency(inputs)
	if (locale === "es-419") return es_419_coach_suggest_frequency(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_suggest_frequency(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_suggest_frequency(inputs)
	if (locale === "de-DE") return de_de2_coach_suggest_frequency(inputs)
	if (locale === "it-IT") return it_it2_coach_suggest_frequency(inputs)
	return en_us2_coach_suggest_frequency(inputs)
});
export { coach_suggest_frequency as "coach.suggest_frequency" }